import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Mediaclip } from '../interfaces/mediaclip';

@Pipe({name: 'clipIcon'})

export class ClipIconPipe implements PipeTransform {

	constructor(private translate: TranslateService) { }

	transform(clip: Mediaclip): string {
		if (!clip) {
			return '';
		}
		let icon: string;
		const mediaType = String(['MediaClipList', 'Project'].includes(clip.type) ? clip.type : clip.mediatype).toLowerCase();

		switch (mediaType) {
			case 'video':
				icon = '<i class="fa fa-film" title="' + this.translate.instant('VIDEO').toLowerCase() + '"></i>';
				break;
			case 'image':
				icon = '<i class="fa fa-image" title="' + this.translate.instant('IMAGE').toLowerCase() + '"></i>';
				break;
			case 'audio':
				icon = '<i class="fa fa-volume-up" title="' + this.translate.instant('AUDIO').toLowerCase() + '"></i>';
				break;
			case 'interactive':
				icon = '<i class="fa fa-cog" title="' + this.translate.instant('INTERACTIVE').toLowerCase() + '"></i>';
				break;
			case 'document':
				icon = '<i class="fa fa-file" title="' + this.translate.instant('DOCUMENT').toLowerCase() + '"></i>';
				break;
			case 'font':
				icon = '<i class="fa fa-font" title="' + this.translate.instant('FONT').toLowerCase() + '"></i>';
				break;
			case 'text':
				icon = '<i class="fa fa-file-text-o" title="' + this.translate.instant('TEXT').toLowerCase() + '"></i>';
				break;
			case 'mediacliplist':
				icon = '<i class="fa fa-list-ol" title="' + this.translate.instant('PLAYLIST').toLowerCase() + '"></i>';
				break;
			case 'project':
				icon = '<i class="fa fa-paper-plane" title="' + this.translate.instant('PROJECT').toLowerCase() + '"></i>';
				break;
			default:
				icon = '';
		}

		return icon;
	}
}
